import React, { useEffect } from 'react';
import { useAppDispatch } from '../../store/hook';
import { closeModal } from '../../store/features/modalSlice';
import HFbutton from '../common/input/HFbutton';
export interface ModalAlertProps {
  message: string;
  /** 확인 버튼 또는 ESC 로 닫은 뒤 실행할 동작 */
  onClose?: () => void;
}
const ModalAlert = ({
  message,
  onClose: onCloseCallback,
}: ModalAlertProps) => {
  const dispatch = useAppDispatch();

  const onClose = () => {
    dispatch(closeModal());
    onCloseCallback?.();
  };

  useEffect(() => {
    document.addEventListener('keydown', keyboardHandler);
    return () => {
      document.removeEventListener('keydown', keyboardHandler);
    };
  }, []);

  const keyboardHandler = (event: KeyboardEvent) => {
    if (event.key === 'Escape') {
      onClose();
    }
  };

  return (
    <div className="mountAnimation mb-40 w-[335px] rounded-md bg-white p-4 shadow-card">
      <div>
        {/* {message} */}
        {message
          ? message
              .split('\n')
              .map((line, index) => <div key={index}>{line}</div>)
          : '알 수 없는 오류가 발생했습니다.'}
      </div>
      <div className="mt-2 flex justify-end">
        <div className="w-[50px]">
          <HFbutton type="Outlined" onClick={onClose} height={34} isFocus>
            확인
          </HFbutton>
        </div>
      </div>
    </div>
  );
};

export default ModalAlert;
